export const shareGlobalName = 'EMP_SHARE_RUNTIME'
export const shareGlobalVal = 'EMPShareGlobalVal'
export const shareForceRemote = 'EMP_FORCE_REMOTES'
